<template>
    <Dialog v-model:visible="internalVisible" header="Confirm Delete" :modal="true" 
            class="p-fluid w-11 md:w-4 mx-3">
        <div class="confirmation-content">
            <i class="pi pi-exclamation-triangle text-yellow-500 mr-3" style="font-size: 2rem" />
            <span>Are you sure you want to delete. This action cannot be undone.</span>
        </div>
        <template #footer>
            <Button label="Cancel"  @click="cancelDelete" 
                   severity="secondary" />
            <Button label="Delete" @click="confirmDelete" 
                    class="p-button-danger" :loading="loading" />
        </template>
    </Dialog>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';

const props = defineProps({
    visible: {
        type: Boolean,
        default: false
    },
    selectedCount: {
        type: Number,
        default: 0
    },
    loading: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['confirm', 'update:visible']);

const internalVisible = ref(props.visible);

watch(() => props.visible, (newValue) => {
    internalVisible.value = newValue;
});

watch(internalVisible, (newValue) => {
    emit('update:visible', newValue);
});

const confirmDelete = () => {
    emit('confirm');
};

const cancelDelete = () => {
    internalVisible.value = false;
};
</script>

<style scoped>
.confirmation-content {
    display: flex;
    align-items: center;
    gap: 1rem;
}
.p-button-text{
    color: var(--gray-600);
}

</style>